const en = {
  done: 'Done',
  start: 'Start',
  next: 'Next',
  tryAgain: 'Try Again',
  continue: 'Continue',
  numbering: 'Numbering',
  readForMe: 'Read for me',
  revealWords: 'Reveal words',
  dropAnswersHere: 'drop answers here',
  dropTheAnswerHere: 'drop the answer here',
  listenToTheTask: 'Listen to the task',
  listenToTheWordAgain: 'Listen to the word again',
  exitQuestion: 'Exit question',
  readingQuestionActivity: 'Reading question activity',
  listenToAnswerChoice: 'Listen to answer choice {0}',
  readingMode: 'Reading mode',
  closeTheBook: 'Close the book',
  openSettingsMenu: 'Open settings menu',
  trayTab: 'Tray tab',
  dialogueOpen: 'Dialogue open',
  settingsDialog: 'Settings dialog',
  closeSettingsDialog: 'Close settings dialog',
  decreaseFontSize: 'Decrease font size',
  increaseFontSize: 'Increase font size',
  goToTheNextPage: 'Go to the next page',
  goBackOnePage: 'Go back one page',
  pageChangedProgress: 'Page changed progress is {0}',
  bookProgressBarLabel: 'Book progress bar. Press Enter to toggle progress bar state.',
  navigateToPage: 'Navigate to page {0}.',
  progressBarExpanded: 'Progress bar is expanded.',
  progressBarCollapsed: 'Progress bar is collapsed.',
  scoreSummary: 'Score summary',
  hideCaption: 'Hide caption',
  loadingScreen: 'Loading screen',
  loading: 'Loading...',
  savingProgress: 'Saving your progress...',
  revealWord: 'Reveal word',
  close: 'Close',
  questionInstruction: 'Question instruction',
  previousQuestion: 'Previous question',
  nextQuestion: 'Next question',
  missingPicture: 'Missing picture',
  closeDialog: 'Close dialog',
  graphicOrganizerActivity: 'Graphic organizer activity',
  reset: 'Reset',
  instructionHint: 'Instruction hint',
  dropElement: 'Drop element to item {0}.',
  elementMoved: 'Item {0} has been moved to item {1}.',
  listReordered: 'List is reordered. Item {0} is now {1} of {2}. Press Done button to submit answer.',
  elementGrabbed: 'Item {0} is grabbed. Use arrow keys to choose new position.',
  readForMeParagraph: 'Read for me paragraph {0}',
  openRevealWordDialogFor: 'Open reveal word dialog for {0}',
  openConnectItActivity: 'Open the Connect It activity',
  openUnmaskThatActivity: 'Open the Unmask That activity',
  openReadingQuestionActivity: 'Open the Reading Question activity',
  openGraphicOrganizerActivity: 'Open the Graphic Organizer activity',
  openWordCityActivity: 'Open the Word City activity',
  openHangryGoblinsActivity: 'Open the Hangry Goblins activity',
  openCutItOutActivity: 'Open the Cut It Out activity',
  openEvidenceTaggingActivity: 'Open the Evidence Tagging activity',
  storyMap: 'Story Map',
  goBack: 'Go Back',
  moreQuestions: 'You still have more questions to answer.',
};

const spaEsDefault = {
  done: 'Listo',
  start: 'Comenzar',
  next: 'Siguiente',
  tryAgain: 'Intentar otra vez',
  continue: 'Continuar',
  numbering: 'Numeración',
  readForMe: 'Leer en voz alta',
  revealWords: 'También le dicen',
  dropAnswersHere: 'Mover las respuestas aquí',
  dropTheAnswerHere: 'Mover la respuesta aquí',
  listenToTheTask: 'Escuchar la tarea',
  listenToTheWordAgain: 'Escuchar la palabra otra vez',
  exitQuestion: 'Salir de la pregunta',
  readingQuestionActivity: 'Actividad sobre lectura',
  listenToAnswerChoice: 'Escuchar la respuesta {0}',
  readingMode: 'Modo lectura',
  closeTheBook: 'Cerrar el libro',
  openSettingsMenu: 'Abrir menú de configuración',
  trayTab: 'Pestaña de la bandeja',
  dialogueOpen: 'Diálogo abierto',
  settingsDialog: 'Diálogo de configuración',
  closeSettingsDialog: 'Cerrar diálogo de configuración/ajustes',
  decreaseFontSize: 'Disminuir el tamaño de la letra',
  increaseFontSize: 'Aumentar el tamaño de la letra',
  goToTheNextPage: '(Ir a la) siguiente página',
  goBackOnePage: '(Ir a la) página anterior',
  pageChangedProgress: 'El progreso en el cambio de página es {0}',
  bookProgressBarLabel: 'Barra de progreso del libro. Pulse "entrar" para cambiar el estado de la barra de progreso.',
  navigateToPage: 'Ve a la página {0}.',
  progressBarExpanded: 'La barra de progreso está extendida.',
  progressBarCollapsed: 'La barra de progreso está cerrada.',
  scoreSummary: 'Puntuación final',
  hideCaption: 'Ocultar los subtítulos',
  loadingScreen: 'Cargando pantalla',
  loading: 'Cargando...',
  savingProgress: 'Guardando tu progreso...',
  revealWord: 'También le dicen',
  close: 'Cerrar',
  questionInstruction: 'Escuchar las instrucciones de la pregunta',
  previousQuestion: 'Pregunta anterior',
  nextQuestion: 'Siguiente pregunta',
  missingPicture: 'La imagen que falta',
  closeDialog: 'Cerrar el diálogo',
  graphicOrganizerActivity: 'Actividad con organizador gráfico',
  reset: 'Reiniciar',
  instructionHint: 'Pista',
  dropElement: 'Colócalo en {0}.',
  elementMoved: '{0} se ha movido a {1}.',
  listReordered: 'La lista se ha reordenado. {0} ahora es {1} de {2}. Presione el botón Listo para enviar la respuesta.',
  elementGrabbed: 'Ha seleccionado {0}. Utilice las teclas con flechas para elegir una nueva posición.',
  readForMeParagraph: 'Leer el párrafo {0}',
  openRevealWordDialogFor: 'Abrir el diálogo de También le dicen para {0}',
  openConnectItActivity: 'Abrir la actividad de Conéctalo',
  openUnmaskThatActivity: 'Abrir la actividad de Unmask that',
  openReadingQuestionActivity: 'Abrir la actividad de lectura',
  openGraphicOrganizerActivity: 'Abrir la actividad del Organizador Gráfico',
  openWordCityActivity: 'Abrir la actividad de Word City',
  openHangryGoblinsActivity: 'Abrir la actividad de los Tragaletras comelones',
  openCutItOutActivity: 'Abrir la actividad de Cut it Out',
  openEvidenceTaggingActivity: 'Abrir la actividad de Evidence Tagging',
  storyMap: 'Elementos de la historia',
  goBack: 'Volver a las preguntas',
  moreQuestions: 'Todavía tienes más preguntas que responder.',
};

export default {
  en,
  spaEsDefault,
};
